import CoveragePackageAccidentInputs from './CoveragePackageAccidentInputs';
import CoveragePackageContentInput from './CoveragePackageContentInput';
import CoveragePackageCarInputs from './CoveragePackageCarInputs';
import CoveragePackageHouseInput from './InputPRH/CoveragePackageHouseInput';
import CoveragePackageCaravanInputs from './CoveragePackageCaravanInputs';
import CoveragePackageTrailerInputs from './CoveragePackageTrailerInputs';
import { FLAVOUR_NAME } from '../../../../constants/coverable';

interface InputComponent {
    Component: React.ComponentType<{
        isLoading: boolean;
        setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    }>;
    trackFormInputs?: string[];
}

const getCoveragePackageInput = (flavourName: string): InputComponent | undefined => {
    switch (flavourName) {
        case FLAVOUR_NAME.ACC_ACCIDENT:
        case FLAVOUR_NAME.ACC_YOUNG:
        case FLAVOUR_NAME.ACC_CHILD:
            return {
                Component: CoveragePackageAccidentInputs,
                trackFormInputs: ['insuranceSum']
            };
        case FLAVOUR_NAME.PRC_CONTENT:
        case FLAVOUR_NAME.PRC_YOUTH_CONTENT:
            return {
                Component: CoveragePackageContentInput,
                trackFormInputs: ['contentAndBaggageCovDeductible']
            };
        case FLAVOUR_NAME.MVP_CAR:
            return {
                Component: CoveragePackageCarInputs,
                trackFormInputs: ['deductible', 'yearlyMileage.displayName']
            };
        case FLAVOUR_NAME.UVP_CARAVAN:
            return {
                Component: CoveragePackageCaravanInputs
            };
        case FLAVOUR_NAME.UVP_TRAILER:
            return {
                Component: CoveragePackageTrailerInputs
            };
        case FLAVOUR_NAME.PRH_HOUSE:
        case FLAVOUR_NAME.PRH_HOLIDAY_HOME:
            return {
                Component: CoveragePackageHouseInput,
                trackFormInputs: ['contentInsuranceSum', 'contentInsuranceManualSum']
            };
        default:
            break;
    }
};

export default getCoveragePackageInput;
